import { render } from "./LandingMaridaje.vue?vue&type=template&id=631b79f9&scoped=true"
import script from "./LandingMaridaje.vue?vue&type=script&lang=js"
export * from "./LandingMaridaje.vue?vue&type=script&lang=js"

import "./LandingMaridaje.vue?vue&type=style&index=0&id=631b79f9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-631b79f9"]])

export default __exports__